import React from 'react';
import { connect } from 'react-redux';
import {Nav, Navbar, NavDropdown, MenuItem,  NavItem} from "react-bootstrap";

import {Link} from "react-router-dom";
import { auth } from '../firebase';

import '../global.css'
import './Navigation.css';


const PathAwareNavItem = props => {
    const pageURI = window.location.pathname+window.location.search;
    const className = (props.className ? props.className : "") + " ";
    const liClassName = className + ((props.path === pageURI) ? "active" : "");

    return (
        <li className={liClassName}>
            <Link to={props.path}> {props.name} </Link></li>
    );
};

const DropDown = props => {
    const { isAdmin } = props;
   const style = {
      color: '#F1B708',
   };
   const name = displayNameFromUsername(props.username);

    return (
        <NavDropdown className="navbar-dropdown" style={style} title={name} id="basic-nav-dropdown">
            <PathAwareNavItem className="font-bigger" path="/games" name="Hunts"/>
            <PathAwareNavItem className="font-bigger" path="/account" name="Account"/>
            { isAdmin && <PathAwareNavItem className="font-bigger" path="/admin" name="Admin"/> }
            <PathAwareNavItem className="font-bigger" path="/pw-forget" name="Reset Password"/>
            <MenuItem divider />
            <MenuItem className="font-bigger" eventKey="signout" onSelect={signOut}>Sign out</MenuItem>
        </NavDropdown>
    );
};

function displayNameFromUsername(username) {
   if (!username) return "Unknown";

   if (username.length <= 10) return username;
   else return username.substring(0, 8) + "."
}

function signOut(event) {
    if (event === "signout") {
        auth.doSignOut()
    }
    else {
        console.warn("UNKNOWN event in Navigation.js signOut():", event);
    }
}

function nameFromUser(user) {

    if (!user) return "";

    const { name } = user;

    return name
        ? name.toLowerCase()
        : "Signed In"
}

class Navigation extends React.Component {
    render() {

        const { authUser, user, isAdmin } = this.props;
        const isSignedIn = !!authUser;
        const username = nameFromUser(user);

        // bg
        return (
                <Navbar collapseOnSelect className="row container-fluid Navbar-margins navbar-default">
                    <Navbar.Header className="col-sm-1 col-md-2 Navigation-no-padding-left">
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Nav>
                            <NavItem className="NavItem-padding-right" href="https://www.ourtreasurehunt.com/home"> our treasure hunt </NavItem>
                            <NavItem className="NavItem-padding" href="https://www.ourtreasurehunt.com/contactus"> reach out </NavItem>
                           { isSignedIn ? <DropDown username={username} isAdmin={isAdmin}/>
                              : <PathAwareNavItem className="NavItem-padding" path="/signin" name="login"/>  }
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
        )
    }
}

const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser,
    isAdmin: state.sessionState.isAdmin,
    user: state.userState.user,
});

export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js